ul {
  padding-inline-start: 0px;
}

.highlight {
  font-size: inherit;
  font-weight: 700;
  line-height: 22px;
}
